import { createClient } from "@supabase/supabase-js";

const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? "";
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? "";

export const supabaseConfigured = Boolean(url && anonKey);

if (!supabaseConfigured) {
  console.warn(
    "[Runway Sync] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing in .env.local. " +
      "Showcase will render but DB-backed views (schedule, dispatch, progress) cannot load.",
  );
}

const safeUrl = supabaseConfigured ? url : "https://placeholder.supabase.co";
const safeKey = supabaseConfigured ? anonKey : "placeholder-anon-key";

export const supabase = createClient(safeUrl, safeKey, {
  auth: {
    persistSession: supabaseConfigured,
    autoRefreshToken: supabaseConfigured,
    detectSessionInUrl: supabaseConfigured,
    storageKey: "runway-sync.auth",
  },
});

export const DEMO_SCHOOL_SLUG = "skyhawk-vobg";
